export const ROUTES = {
  LOGIN_PAGE: "/login",
  // TWO_FA: '/two-factor-authentication',

  MAIN_PAGE: "/",
  PLAYERS: "/players",
  USERS: "/users",
  PLANS: "/plans",
  SETTINGS: "/settings",
  TRANSACTIONS: "/transactions",
  POPUPS: "/popups",
  NOTIFICATIONS: "/notifications",
  CONFIGURATIONS: "/configurations",

  NOT_FOUND: "*",
  INTERNAL_SERVER: "/500",
  ACCESS_DENIED: "/403",
  RESTRICTED_USERNAMES: "/restricted-usernames",
  STORE_BANNERS: "/store-banners",
  HOME_HERO_CARDS: "/home-hero-cards",
  TIERS: "/tiers",
  BASELINES: "/baselines",
  RANKED_SEASON_ANNOUNCEMENT: "/ranked-season-announcement",
  CAMPAIGNS: "/campaigns",
  CAMPAIGN_PROMO_CODES: "/campaign-promo-codes",
  AFFILIATE_DAILY_REVENUE: "/affiliate/daily-revenue",
};
